import { render, staticRenderFns } from "./newsLocation.vue?vue&type=template&id=cf5b6e68"
import script from "./newsLocation.vue?vue&type=script&lang=js"
export * from "./newsLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports